import { useEffect, useState } from "react";
import { useApiCall } from "../../api/api";
import { TeamAvailability } from "../../api/dto";
import { useSelectedDay } from "../DateContext";
import { getWeek } from "@traas/lib/src/util/getWeekNumber";
import { useRealtimeMessages } from "@traas/lib/src/realtime/RealtimeConnectionContext";

export const useTeamAvailability = (): TeamAvailability | null => {
  const { day } = useSelectedDay();
  const { getTeamAvailability } = useApiCall();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teamAvailability, setTeamAvailability] = useState<TeamAvailability | null>(null);

  useRealtimeMessages((message) => {
    if (
      message.type === "teams_updated" ||
      message.type === "employees_updated" ||
      message.type === "holidays_updated"
    ) {
      load(day);
    }
  });

  const load = async (date: Date): Promise<void> => {
    setIsLoading(true);
    await getTeamAvailability(date).then(setTeamAvailability);
    setIsLoading(false);
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (teamAvailability === null) {
      load(day);
      return;
    }
    if (getWeek(day) !== teamAvailability.weekNumber) {
      load(day);
      return;
    }
  }, [day, teamAvailability, isLoading]);

  return teamAvailability;
};
